import { Formik } from 'formik';
import { useContext } from 'react';
import * as Yup from 'yup';
import { executeGQL } from '../../lib/api';
import { BASE_URL } from '../../lib/config';
import { useTranslation } from '../../lib/i18n';
import { trackEvent } from '../../lib/tracking';
import { Button } from '../common/button';
import { ToastContext } from '../toast/toast-context';
import { TextInput } from './fields';

export const PwResetForm = ({ className = '' }) => {
  const { toast } = useContext(ToastContext);
  const { t } = useTranslation();
  return (
    <div className={className}>
      <h1 className='mb-2 text-center'>{t('pwResetHeading')}</h1>
      <p className='mb-6 text-center'>{t('pwResetDescription')}</p>

      <div>
        <Formik
          initialValues={{
            email: '',
          }}
          validationSchema={Yup.object({
            email: Yup.string()
              .email(t('invalidEmail'))
              .required(t('required')),
          })}
          onSubmit={async (values, { setSubmitting, resetForm, setErrors }) => {
            const { hasErrors, errors } = await executeGQL(
              'requestPasswordReset',
              {
                email: values.email,
                redirectUrl: `${BASE_URL}/set-pw/`,
              },
            );

            if (hasErrors) {
              toast.show(t('genericError'), {
                type: 'error',
                timeout: 0,
              });
              setErrors(errors);
              setSubmitting(false);
            } else {
              trackEvent({
                category: 'form',
                action: 'submit',
                label: 'password reset',
              });
              resetForm({});
              setSubmitting(false);
              toast.show(t('pwResetConfirmation'), {
                timeout: 0,
              });
            }
          }}
        >
          {(props) => (
            <form onSubmit={props.handleSubmit} className={`mx-auto max-w-md`}>
              <TextInput
                id='email'
                className='mt-2'
                name='email'
                autoComplete='email'
                placeholder={t('email')}
                type='email'
                label={t('email')}
              />
              <Button
                loading={props.isSubmitting}
                type='submit'
                className='mt-8'
                filled
                wide
              >
                {t('send')}
              </Button>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};
